import {createTheme, Theme} from '@mui/material';
import {COLORS} from '@fupa/fupa-uikit';

const theme: Theme = createTheme({
  // @ts-ignore
  shadows: [
    ...createTheme({}).shadows.map((shadow, i) =>
      i === 3
        ? '0px 3px 3px -2px rgba(145, 158, 171,0.2), 0px 3px 4px 0px rgba(145, 158, 171,0.14),0px 1px 8px 0px rgba(145, 158, 171,0.12)'
        : shadow
    ),
  ],
  typography: {
    fontFamily: 'PT Sans, sans-serif',
  },
  palette: {
    primary: {main: COLORS.fupaSecondary, dark: COLORS.fupaSecondaryFocused},
    secondary: {main: COLORS.lightestGrey, dark: COLORS.lighterGrey},
    info: {main: COLORS.darkerGrey},
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Oswald, Arial Narrow, Avenir Next Condensed, MS UI Gothic, sans‑serif',
        },
      },
    },
    MuiIconButton: {
      defaultProps: {
        color: 'info',
      },
    },
  },
});

export default theme;
